"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var EventType_1 = require("../../model/types/EventType");
var AbstractEvent_1 = require("./AbstractEvent");
var PageViewedEvent = (function (_super) {
    __extends(PageViewedEvent, _super);
    function PageViewedEvent() {
        return _super.call(this) || this;
    }
    PageViewedEvent.prototype.getType = function () {
        return EventType_1.EventType.PageViewed;
    };
    return PageViewedEvent;
}(AbstractEvent_1.AbstractEvent));
exports.PageViewedEvent = PageViewedEvent;
//# sourceMappingURL=PageViewedEvent.js.map